import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { GraduationCap, Moon, Sun, TrendingUp, Flame } from "lucide-react";
import { Button } from "@/components/ui/button";
import ReminderMenu from "@/components/ReminderMenu";

export default function Header() {
  const [dark, setDark] = useState(() => localStorage.getItem("theme") === "dark");

  useEffect(() => {
    const root = document.documentElement;
    if (dark) {
      root.classList.add("dark");
      localStorage.setItem("theme", "dark");
    } else {
      root.classList.remove("dark");
      localStorage.setItem("theme", "light");
    }
  }, [dark]);

  return (
    <header
      data-testid="app-header"
      className="backdrop-blur-md bg-background/80 border-b border-border sticky top-0 z-40"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2.5 group">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary text-primary-foreground shadow-sm group-hover:scale-105 transition-transform">
            <GraduationCap className="h-5 w-5" />
          </span>
          <span className="font-display text-xl font-extrabold tracking-tight">
            Studio<span className="text-primary">AI</span>
          </span>
        </Link>
        <div className="flex items-center gap-1.5">
          <Button asChild variant="ghost" className="rounded-xl gap-2 text-sm" data-testid="nav-daily">
            <Link to="/daily">
              <Flame className="h-4 w-4 text-orange-500" />
              <span className="hidden sm:inline">Sfida</span>
            </Link>
          </Button>
          <Button
            asChild
            variant="ghost"
            className="rounded-xl gap-2 text-sm"
            data-testid="nav-progress"
          >
            <Link to="/progress">
              <TrendingUp className="h-4 w-4" />
              <span className="hidden sm:inline">Progressi</span>
            </Link>
          </Button>
          <ReminderMenu />
          <Button
            data-testid="theme-toggle"
            variant="ghost"
            size="icon"
            onClick={() => setDark((d) => !d)}
            className="rounded-xl"
            aria-label="Cambia tema"
          >
            {dark ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
          </Button>
        </div>
      </div>
    </header>
  );
}
